export const CasesEditTabs = [
  { section: 'common', title: 'Общая информация' },
  { section: 'violation', title: 'Нарушения' },
  { section: 'decisions', title: 'Решения' },
];
